<molecule-data-list-wrapper
    [searchType]="searchType"
    [searchTypePlural]="searchTypePlural"
    [searchPlaceholder]="searchPlaceholder"
    [isLoading]="isLoading"
    [hasError]="hasError"
    [isForInfinityScroll]="true"
    [limit]="limit"
    [filterHandler]="filterHandler"
    [filtersModalId]="filtersModalId"
    [sortMenu]="sortMenu"
    [useSortToggleMenu]="useSortToggleMenu"
    [totalRecordCount]="totalRecordCount"
    [showFilters]="showFilters"
    [showFilterBar]="showFilterBar"
    [showSearchBar]="showSearchBar"
    [showFavourite]="showFavourite"
    [cySelector]="cySelector"
    [favouriteFilterToggle]="favouriteFilterToggle"
    (infinityScrollFired)="onInfinityScrollFired()"
>
    <ng-content prefixActionButtons select="[prefixActionButtons]"></ng-content>

    <div class="data-list-action-button">
        <ng-content select=".organism-cards-list-action-button"></ng-content>
    </div>
    @if (cardType === CARD_TYPE.Case && showLegend) {
        <div class="data-list-header-content mb-2 d-none d-lg-block">
            <molecule-legend [items]="legendItems"></molecule-legend>
        </div>
    }
    <div
        class="data-list-content max-h-100"
        [class.widget-container]="addWidgetContainerPadding"
    >
        @if (
            caseCards
                | fn: getCards : opportunityCards : activityCards : cardType;
            as cards
        ) {
            @if (totalRecordCount || isLoading) {
                @switch (scrollMode) {
                    @case (SCROLL_MODE.Carousel) {
                        <ngb-carousel class="w-100 h-100" [interval]="false">
                            @for (card of cards; track card.id) {
                                <ng-template ngbSlide>
                                    <ng-container
                                        *ngTemplateOutlet="
                                            cardTypeSwitch;
                                            context: { card: card }
                                        "
                                    ></ng-container>
                                </ng-template>
                            }
                        </ngb-carousel>
                    }
                    @case (SCROLL_MODE.Horizontal) {
                        <ng-container
                            *ngTemplateOutlet="horizontalScroll"
                        ></ng-container>
                    }
                    @case (SCROLL_MODE.Responsive) {
                        <div class="d-none d-xl-block h-100">
                            <ng-container
                                *ngTemplateOutlet="defaultScroll"
                            ></ng-container>
                        </div>
                        <div class="d-block d-xl-none h-100">
                            <ng-container
                                *ngTemplateOutlet="horizontalScroll"
                            ></ng-container>
                        </div>
                    }
                    @default {
                        <ng-container
                            *ngTemplateOutlet="defaultScroll"
                        ></ng-container>
                    }
                }
                <ng-template #defaultScroll>
                    <div class="max-h-100 grid">
                        @for (card of cards; track card.id) {
                            <div
                                class="data-list-content__card-container g-col"
                                [class.suggested-card]="isSuggestedCardList"
                                [responsiveColumns]="{
                                    staticColumns: cardsPerRow,
                                }"
                            >
                                <ng-container
                                    *ngTemplateOutlet="
                                        cardTypeSwitch;
                                        context: { card: card }
                                    "
                                ></ng-container>
                            </div>
                        }
                    </div>
                </ng-template>
                <ng-template #horizontalScroll>
                    <molecule-tile-carousel
                        class="d-block h-100"
                        [tiles]="tileCarouselCards"
                    >
                        @for (card of cards; track card.id) {
                            <div
                                #tileCarouselCard
                                class="data-list-content__card-container data-list-content__card-container--set-width"
                                [class.suggested-card]="isSuggestedCardList"
                            >
                                <ng-container
                                    *ngTemplateOutlet="
                                        cardTypeSwitch;
                                        context: { card: card }
                                    "
                                ></ng-container>
                            </div>
                        }
                    </molecule-tile-carousel>
                </ng-template>
            } @else {
                @if (showNoDataSVG) {
                    <div
                        class="d-flex h-100 align-items-center justify-content-center"
                    >
                        <atom-feature-svg
                            [svg]="FEATURE_SVG.NoData"
                            [size]="noDataSVGSize"
                        >
                            {{ noDataMessage }}
                        </atom-feature-svg>
                    </div>
                }
            }
        }
    </div>
</molecule-data-list-wrapper>

<ng-template #cardTypeSwitch let-card="card">
    @switch (cardType) {
        @case (CARD_TYPE.Case) {
            <molecule-case-card
                class="data-list-content__card d-block h-100"
                [caseCardItem]="card"
                (refreshCases)="onRefreshCases()"
            ></molecule-case-card>
        }
        @case (CARD_TYPE.Opportunity) {
            <molecule-opportunity-card
                class="data-list-content__card d-block h-100"
                [opportunity]="card"
                [fullCardLink]="true"
            ></molecule-opportunity-card>
        }
        @case (CARD_TYPE.Activity) {
            <molecule-activity-card
                class="data-list-content__card d-block h-100"
                [activityCard]="card"
            ></molecule-activity-card>
        }
    }
</ng-template>

@if (filtersModalId) {
    <atom-modal-wrapper
        [modalId]="filtersModalId"
        [modalTemplate]="filtersModal"
    >
        <ng-template #filtersModal>
            <organism-modal modalTitle="Filter">
                @if (hasFilterSearch) {
                    <clmi-form-filters class="h-100 w-100"></clmi-form-filters>
                }
            </organism-modal>
        </ng-template>
    </atom-modal-wrapper>
}
